import axios from 'axios';

const api = axios.create({
    baseURL: window._env_?.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE_URL || 'http://localhost:8081/api'
});

// Add request interceptor for debugging
api.interceptors.request.use(request => {
  console.log('API Request:', {
    method: request.method,
    url: request.url,
    data: request.data
  });
  return request;
});

// Add response interceptor for debugging
api.interceptors.response.use(
  response => {
    console.log('API Response:', {
      status: response.status,
      data: response.data
    });
    return response;
  },
  error => {
    console.error('API Error:', {
      message: error.message,
      response: error.response
    });
    return Promise.reject(error);
  }
);

export const workflowApi = {
  getTasks: () => api.get('/tasks'),
  createTask: (task) => api.post('/tasks', task),
  getTemplates: () => api.get('/templates'),
  getTemplate: (id) => api.get(`/templates/${id}`),
  createTemplate: (template) => api.post('/templates', template),
  getInstances: () => api.get('/instances'),
  resumeInstance: (id) => api.post(`/instances/${id}/resume`),
  cancelInstance: (id) => api.delete(`/instances/${id}`),
  startWorkflow: (templateId, context) => api.post(`/instances?templateId=${templateId}`, context),
  getTaskExecution: (workflowId, nodeId, checksum) => api.get(`/tasks/executions/${workflowId}/${nodeId}/${checksum}`),
  deleteTemplate: (id) => api.delete(`/templates/${id}`),
  deleteTask: (id) => api.delete(`/tasks/${id}`),
  getPausedExecutions: () => api.get('/executions/paused'),
  resumePausedExecution: (data) => api.post('/executions/instances/resume', data),
  getConfigurations: () => api.get('/configurations'),
  getConfiguration: (id) => api.get(`/configurations/${id}`),
  upsertConfiguration: (data) => api.post('/configurations/upsert', data),
  deleteConfiguration: (id) => api.delete(`/configurations/${id}`),
  deactivateConfiguration: (id) => api.post(`/configurations/${id}/deactivate`),
  clearConfigurationCache: () => api.post('/configurations/cache/clear'),
  getSystemConfiguration: (id) => api.get(`/configurations/${id}/system`),
  upsertSystemConfiguration: (id, data) => api.post(`/configurations/${id}/system`, {
    value: data.value,
    description: data.description
  }),
  getWorkflowConfiguration: (configId, workflowId) => api.get(`/configurations/${configId}/workflow/${workflowId}`),
  upsertWorkflowConfiguration: (configId, workflowId, data) => api.post(`/configurations/${configId}/workflow/${workflowId}`, {
    nodeConfigs: data.nodeConfigs,
    description: data.description
  }),
  getNodeConfiguration: (configId, workflowId, nodeId) => api.get(`/configurations/${configId}/workflow/${workflowId}/node/${nodeId}`),

  // Transaction Sync Status
  getTransactionSyncStatuses: (params) => api.get('/transaction-sync', { params }),
  getTransactionSyncSummary: () => api.get('/transaction-sync/summary'),
  getTransactionSyncByRealmId: (realmId) => api.get(`/transaction-sync/realm/${realmId}`),
  getTransactionSyncByOrgId: (orgId, params) => api.get(`/transaction-sync/org/${orgId}`, { params }),
};
